import { gql } from '@apollo/client';

export const CREATE_CUSTOM_ORDER = gql`
  mutation CreateCustomOrder(
    $orderType: Int!
    $deliveryAddress: String
    $storeId: ID
    $eventDate: Date!
    $eventTime: String
    $assortment: Boolean!
    $products: [ProductQuantityInput!]
    $additionalProductRequests: String
    $individualWaxWrapped: Boolean!
    $individualCellophaneWrapped: Boolean!
		$iceCream:Boolean!
		$iceCreamDescription: String
    $name: String!
    $phoneNumber: String!
    $email:String!
    $preferredContactMethod:String!
    $paymentMethod: String!
    $gratuityPercentage: Float
    $gratuityAmount: Float
		$reasonForShopping:String
  ) {
    createCustomOrder(
      orderType: $orderType
      deliveryAddress: $deliveryAddress
      storeId: $storeId
      eventDate: $eventDate
      eventTime: $eventTime
      assortment: $assortment
      products: $products
      additionalProductRequests: $additionalProductRequests
      individualWaxWrapped: $individualWaxWrapped
      individualCellophaneWrapped: $individualCellophaneWrapped
      iceCream: $iceCream
      iceCreamDescription: $iceCreamDescription
      name: $name
      phoneNumber: $phoneNumber
      email: $email
      preferredContactMethod: $preferredContactMethod
      paymentMethod: $paymentMethod
      gratuityPercentage: $gratuityPercentage
      gratuityAmount: $gratuityAmount
      reasonForShopping: $reasonForShopping
    ) {
      success
      message
      errors
    }
  }
`;
